/**
 * OUW-276 — la marca de «este cliente salió a firmar su SOLICITUD con Logalty».
 *
 * Al terminar la firma, api-client devuelve al cliente directo a su portal (`/status/solicitud`),
 * y producto quiere que esa primera vez el portal lo reconozca: «¡Listo! Recibimos tu firma.»
 * (Lucía, 06-oct). El portal no tiene otra forma de saber que la visita viene de la firma: el
 * destino no trae ningún parámetro y el estado de la solicitud ya puede haber seguido de largo.
 *
 * Mismo criterio que la marca de la firma de la OFERTA (OUW-186, `offerSignatureService`): va en
 * `sessionStorage` y no en la URL, así sobrevive la vuelta por Logalty y api-client (misma
 * pestaña, mismo origen) sin tocar el backend. La pone `/logalty` justo antes de mandar al
 * cliente a firmar —también en un reintento o al retomar— y la borra si vuelve sin completar la
 * firma. El portal la consume (la lee y la borra): el aviso sale una sola vez.
 */
const APPLICATION_SIGNATURE_MARK = 'ole.application.signatureStarted';

/** Una vuelta de Logalty más vieja que esto ya no es «recién firmó». */
export const APPLICATION_SIGNATURE_MARK_TTL_MS = 60 * 60 * 1000;

export function markApplicationSignatureStarted(quoteId: string, now = Date.now()): void {
  if (!quoteId) return;
  try {
    window.sessionStorage.setItem(APPLICATION_SIGNATURE_MARK, JSON.stringify({ quoteId, at: now }));
  } catch {
    // Navegación privada o almacenamiento bloqueado: se pierde el aviso, no la firma.
  }
}

export function clearApplicationSignatureMark(): void {
  try {
    window.sessionStorage.removeItem(APPLICATION_SIGNATURE_MARK);
  } catch {
    /* idem */
  }
}

/**
 * ¿Esta visita al portal de `quoteId` viene directo de firmar? La marca se borra al leerla si es
 * de esta solicitud, así el aviso no vuelve al recargar. Una marca de otra solicitud se deja.
 */
export function takeApplicationSignatureMark(quoteId: string, now = Date.now()): boolean {
  try {
    const raw = window.sessionStorage.getItem(APPLICATION_SIGNATURE_MARK);
    if (!raw || !quoteId) return false;
    const mark = JSON.parse(raw) as { quoteId?: string; at?: number };
    if (mark.quoteId !== quoteId) return false;
    window.sessionStorage.removeItem(APPLICATION_SIGNATURE_MARK);
    return typeof mark.at === 'number' && now - mark.at >= 0 && now - mark.at < APPLICATION_SIGNATURE_MARK_TTL_MS;
  } catch {
    return false;
  }
}
